<template >
  <div class="wizard-wrapper">
    <router-view />
    <!-- v-slot="{ Component }" -->
    <!-- <transition name="step" mode="out-in">
        <component :is="Component"></component>
      </transition> -->
    <!-- </router-view> -->
  </div>
</template>

<style lang="scss" scoped >
.wizard-wrapper :deep(*) {
  @import './styles/global.scss';
}

.step-enter-active,
.step-leave-active {
  transition: 600ms ease all;
}

.step-enter-from,
.step-leave-to {
  opacity: 0;
  transform: translateY(60px);
}
</style>
